<div class="col-sm-12 no-padding">
  <div class="accordion" id="accordion2CW">
    <div class="accordion-group">
      <div class="accordion-heading">
        <button (click)="toggleAccordionCW()" class="accordion-toggle btn btn-link btn-block clearfix accordion-btn" data-toggle="collapse" data-parent="#accordion2CW" href="#collapseOneCW">
          <div class="row">
            <div class="pull-left font-weight-light bp-text bp-small-text col-md-8 text-align-left no-padding"><i class="fas arrowdiv-cw arrowdiv fa-chevron-right"></i> COLD WEATHER ALERTS</div>
            <div *ngIf="textSubscribedCW || emailSubscribedCW" class="col-md-4 green text-align-right">Subscribed</div>
            <div *ngIf="!textSubscribedCW && !emailSubscribedCW" class="col-md-4"></div>
          </div>
        </button>
      </div>
      <div id="collapseOneCW" class="accordion-body collapse">
        <div class="row">
          <div class="col-sm-12 no-padding">
            <p class="text-align-left title-small font-weight-light bp-text bp-x-small-text">
              Whenever the temperature goes below the value that you enter below (32&#176;F by default), you will be alerted. This is useful so you can drip your faucets to avoid pipes bursting in freezing temperatures.
            </p>
          </div>
        </div>
        <div class="accordion-inner">
          <div *ngIf="!subscribedCW" class="row subscribeSection">
            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <button type="button" class="btn btn-light bp-text bp-medium-text" style="font-weight: 600;color: #3F8F8B;" (click)="onSubscribeClickCW()">+ SUBSCRIBE</button>
            </div>
          </div>
          <div *ngIf="subscribedCW" class="row subscribeSection">
            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12">
                <label for="cw-buffer-input" class="bp-text">Cold Weather Temperature Alarm Trigger (&deg;F):</label>
                <input type="number" value="{{degreeInput}}" (ngModel)="degreeInput" class="form-control" (change)="setDegreeValue($event.target.value)" id="cw-buffer-input" />
              </div>
            </div>
            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12"><span class="bp-text bp-small-text">Contact Type:</span></div>
              <div class="col-sm-12">
                <div class="btn-group">
                  <label class="btn btn-primary subscription-container" (click)="showEmailInput()"
                         btnRadio="email" tabindex="0" role="button"><i style="margin-right: 0.3rem;" class="far fa-envelope"></i>Email</label>
                  <label class="btn btn-primary subscription-container" (click)="showPhoneSelect()"
                         btnRadio="text" tabindex="0" role="button"><i style="margin-right: 0.3rem;" class="fas fa-mobile-alt"></i>Text</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12"><span style="float:left;" class="bp-text bp-small-text">Destination:</span></div>
            </div>
            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12 bp-text bp-small-text">
                <div *ngIf="showPhoneCW" class="form-group">
                  <span>
                    <select class="form-control select-medium" name="phone" [(ngModel)]="accountPhoneCW">
                      <option *ngFor="let phone of accountPhonesCW" [value]="phone">{{ phone }}</option>
                    </select>
                  </span>
                  <div class="margin-top-10">
                    <small class="green" *ngIf="textSubscribedCW"> (Text Subscribed)</small>
                    <input type="text" class="btn btn-xs btn-danger float-right" *ngIf="textSubscribedCW" (click)="removeCWAlert(true, false)" value="Remove Text Alerts" />
                  </div>
                </div>
                <div *ngIf="showEmailCW">
                  <span class="bp-text bp-bold-text" *ngIf="showEmailCW">{{accountEmailCW}}</span>
                  <div class="margin-top-10">
                    <small class="green" *ngIf="emailSubscribedCW"> (Email Subscribed)</small>
                    <input type="text" class="btn btn-xs btn-danger float-right" *ngIf="emailSubscribedCW" (click)="removeCWAlert(false, true)" value="Remove Email Alerts" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row bp-text bp-small-text" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12"><button (click)="onSaveCWAlertClick()" class="btn btn-primary" type="button">SAVE</button></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/cold-weather-alerts/cold-weather-alerts.component.html